import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { cancel_confirmation_path, root_path } from '@routes';
import { FreeProTrialParams, freeProTrial } from '@utils/backend-api/subscribe';

import { ConfirmationTypes } from '../components/pages/Cancel/Confirmation/constants';

const useFreeProTrial = (isCancelConfirmation: boolean = false) => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: FreeProTrialParams) => freeProTrial(params),
    {
      onSuccess: () => {
        const anchor = document.createElement('a');
        if (isCancelConfirmation) {
          anchor.href = cancel_confirmation_path({
            confirmation_type: ConfirmationTypes.Offer,
          });
        } else {
          anchor.href = root_path();
        }
        anchor.click();
      },
      onError: () => {
        toast.error('Something went wrong. Please try again later.');
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default useFreeProTrial;
